import { render, staticRenderFns } from "./resume-positions-view.vue?vue&type=template&id=ef5890be&"
import script from "./resume-positions-view.vue?vue&type=script&lang=js&"
export * from "./resume-positions-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports